export const ameya = {
  slug: "ameya",
  name: "Ameya",
  location: "Near RRR, South Hyderabad",
  approval: "MUDA approved and RERA registered",
  acreage: "30 acres",
  status: "Limited availability",
  logo: "/projects/ameya/logo.png",
  hero: "/projects/ameya/aerial-layout.webp",
  summary:
    "A 30-acre plotted venture with wide roads, parks, and 30+ amenities planned for future residential development.",
  description:
    "Ameya should feel structured and documentation-ready: aerial road networks, utility details, boundary walls, plot markers, and amenity structures all help buyers assess readiness.",
  layoutImages: [{ src: "/projects/layouts/Ameya-layout.webp", alt: "Ameya layout preview", label: "Layout preview" }],
  approvalImages: [],
  featuredImages: [
    {
      src: "/projects/ameya/aerial-roads.webp",
      alt: "Ameya road network aerial",
      title: "Clear road network",
      copy: "The aerial road grid gives buyers an immediate understanding of access and plot organization."
    },
    {
      src: "/projects/ameya/gazebo.webp",
      alt: "Ameya gazebo",
      title: "Amenity character",
      copy: "Gazebo and landscape structures make the venture feel residential, not just transactional."
    },
    {
      src: "/projects/ameya/bridge-feature.webp",
      alt: "Ameya bridge feature",
      title: "Signature site elements",
      copy: "Distinct physical features help the project stay memorable during comparison."
    }
  ],
  galleryImages: [
    ["/projects/ameya/aerial-layout.webp", "Aerial plotted layout"],
    ["/projects/ameya/aerial-roads.webp", "Aerial view of roads and plots"],
    ["/projects/ameya/circular-amenity-aerial.webp", "Circular amenity feature"],
    ["/projects/ameya/plot-marker.webp", "Plot marker"],
    ["/projects/ameya/utility-chamber.webp", "Utility chamber"],
    ["/projects/ameya/straight-road.webp", "Straight internal road"],
    ["/projects/ameya/boundary-wall.webp", "Boundary wall"],
    ["/projects/ameya/median-road.webp", "Median road"],
    ["/projects/ameya/water-provision.webp", "Water provision"],
    ["/projects/ameya/palm-road.webp", "Palm-lined road"],
    ["/projects/ameya/plot-signage.webp", "Plot signage"],
    ["/projects/ameya/pergola.webp", "Pergola structure"],
    ["/projects/ameya/stage-structure.webp", "Stage structure"],
    ["/projects/ameya/gazebo.webp", "Gazebo"],
    ["/projects/ameya/structure-work.webp", "Structure work"],
    ["/projects/ameya/security-room.webp", "Security room"],
    ["/projects/ameya/compound-wall.webp", "Compound wall"],
    ["/projects/ameya/bridge-feature.webp", "Bridge feature"]
  ],
  facts: [["Approval", "MUDA + RERA"], ["Extent", "30 acres"], ["Amenities", "30+"], ["Parks", "4"]],
  amenities: ["Avenue plantation", "Parks", "Wide roads", "Security planning", "Children's play spaces"]
};
